module.exports = __webpack_public_path__ + "img/appartments.11cdab1b.png";